import { useMemo } from 'react';
import { IExpression } from '../../IExpression';
import { getExpressionValue } from '../../evaluate/getExpressionValue';
import { IUseExpressionValue } from './useExpressionValue';
import { useMaterializedExpressionReferences } from './useMaterializedExpressionReferences';
import { useWatchReferences } from './useWatchReferences';

/**
 * Ottiene il risultato di più espressioni. Per essere calcolato ha
 * bisogno di:
 * 1. Essere all'interno di un FormProvider
 * 2. Avere un nome (name) che sia un path valido per poter calcolare correttamente
 *    le dipendenze in fase di `useWatch`
 *
 * @param name Percorso da quale devono essere risolte le dipendenze
 * @param expression Espressione da valutare
 */
export function useExpressionsValues(
  name: string,
  expressions: Array<IExpression | null | undefined>,
  options?: { skip?: boolean | ((variables: Record<string, any>) => boolean) },
): IUseExpressionValue[] {
  const { references } = useMaterializedExpressionReferences(name, expressions);

  const variables = useWatchReferences(references);

  return useMemo(() => {
    if (
      options?.skip === true ||
      (typeof options?.skip === 'function' && options.skip(variables))
    ) {
      return expressions.map(e => ({ type: 'null' as const }));
    }

    return expressions.map(e =>
      getExpressionValue({ name, expression: e, references, variables }),
    );
  }, [name, expressions, references, variables, options]);
}
